<template>

    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'categorias-clientes', params:{idCompany: idCompany}}">{{$t('categoriasDeClientes')}}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{action}} {{$t('categoriaDeCliente')}}</li>
                    </ol>
                </nav>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-12">
                            <h2 class="tituloNumier"><i class="fa fa-building"></i> {{nombreEmpresa}}</h2>
                            <hr>
                        </div>
                        <div class="col-md-8">
                            <div class="form-group">
                                <label for="nameCasa"><strong>{{$t('nombreCategoria')}} <span
                                        style="color: red">*</span></strong></label>
                                <input type="text" class="form-control"
                                       :class="{'is-valid': categoria.name.length >0 && categoria.name.length <= maxNameCategoria,
                                       'is-invalid': categoria.name.length > maxNameCategoria}"
                                       id="nameCasa" v-bind:placeholder="$t('introduzcaNombre')"
                                       v-model="categoria.name" ref="name">
                                <input type="hidden" v-model="categoria.xname">
                                <small class="form-text text-muted">{{categoria.name.length}}/50</small>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label><strong>{{$t("etiquetaPadre")}}</strong></label>
                                <el-select class="select-default"
                                           size="large"
                                           v-model="categoria.parentId"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')">
                                    <el-option v-for="category in listCategoryParent"
                                               class="select-primary"
                                               :value="category.id"
                                               :label="category.name"
                                               :key="category.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="form-group">
                                    <label>
                                        <strong>{{$t("baja")}}</strong>
                                    </label>
                                    <el-switch v-model="categoria.baja"
                                               active-color="#13ce66"
                                               inactive-color="#bcbcbc">
                                    </el-switch>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <button class="btn btn-primary" @click="saveCategoria()" :disabled="inProgress"><i
                                    class="fa fa-check-square"></i> {{$t("guardar")}}
                            </button>

                            <router-link :to="{name:'categorias-clientes', params:{idCompany: idCompany, 'pag' : pag}}">
                                <button class="btn btn-danger"><i
                                        class="fa fa-window-close"></i>
                                    {{$t("cancelar")}}
                                </button>
                            </router-link>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import swal from 'sweetalert2'
    import {
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button,
        Checkbox,
        Switch
    } from 'element-ui'


    export default {
        name: "CategoriasClientesForm",

        props: ['idCategoriaCliente', 'idCompany', 'pag'],
        created() {
            //this.action = this.idCategoria ? this.$i18n.t("editar") : this.$i18n.t("nueva");


            this.identificacionEmpresa();

            if (this.idCategoriaCliente) {

                this.action='Editar';
                this.getCategoria();
            } else {

                this.action='Nuevo';
                this.getCategoryParent();
            }

        },

        components: {
            [Checkbox.name]: Checkbox,
            [Switch.name]: Switch,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },

        mounted() {
            this.$refs.name.focus();
        },

        data() {
            return {
                categoria: {
                    name: "",
                    xname: "",
                    parentId: 0,
                    baja: false
                },
                listCategory: [],
                maxNameCategoria: 50,
                listCategoryParent: [],
                action: "",
                inProgress: false,
                nombreEmpresa: ""
            }
        },
        methods: {

            identificacionEmpresa() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idCompany: this.idCompany
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'general/identifyCompany', config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.nombreEmpresa = response.data.result

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },

            cancelarRuta() {

            },


            checkCampos() {
                if (this.categoria.name.length > this.maxNameCategoria) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('laLongitudDelNombreNoPuedeSerMayorDe') + this.maxNameCategoria + '.',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else if (this.categoria.name === '' || this.categoria.name.length === 0) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else {
                    return true;
                }
            },
            getCategoria() {
                var config = {
                    params: {
                        idCompany: this.idCompany,
                        idCategory: this.idCategoriaCliente,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'clients/getCategoryClientsById', config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.categoria = response.data.result;
                            vm.categoria.xname = response.data.result.name


                            vm.getCategoryParent();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            getCategoryParent() {

                this.listCategoryParent = [];

                if (this.idCategoriaCliente) {
                    var config = {
                        params: {
                            idCompany: this.idCompany,
                            idCategory: this.idCategoriaCliente,
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                } else {

                    var config = {
                        params: {
                            idCompany: this.idCompany,
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                }

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'clients/getCategoriesClientsParent', config)
                    .then(function (response) {
                        if (response.data.response) {


                            for (let i = 0; i < response.data.result.categories.length; i++) {

                                let categoryname = {
                                    name: response.data.result.categories[i].name,
                                    id: response.data.result.categories[i].id,
                                };

                                vm.listCategoryParent.push(categoryname)

                            }

                            let category = {
                                name: vm.$t('sinCategoria'),
                                id: 0
                            };

                            vm.listCategoryParent.unshift(category)

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },


            saveCategoria() {
                if (this.checkCampos()) {
                    this.inProgress = true;

                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        idCompany: this.idCompany,
                        category: this.categoria,
                        jwt: this.$store.getters.jwt
                    };

                    let vm = this;
                    let controller = this.idCategoriaCliente ? "editCategoryClientBy" : "saveCategoryClient";
                    this.axios.post(this.$store.getters.apiUrl + 'clients/' + controller, params, config)
                        .then(function (response) {
                            vm.inProgress = false;

                            if (response.data.response) {

                                let notify = vm.idCategoriaCliente ? vm.$t('actualizada') : vm.$t('creada');
                                vm.$notify({
                                    message: vm.$t('etiqueta') + ' ' + notify + ' '+vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                vm.$router.push({
                                    name: 'categorias-clientes',
                                    params: {idCompany: vm.idCompany, pag: vm.pag}
                                })

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
                }
            },
        }
    }
</script>

<style scoped>

    .card {
        padding: 20px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Widgets/CategoriasClientes/CategoriasClientesForm.vue